import request from '../request';

export function driverIndex(params) {
  return request({
    url: "/driver/money-management",
    method: "get",
    params
  })
}

export function store(data) {
  return request({
    url: "/driver/money-management",
    method: "post",
    data
  })
}